import { Line } from 'vue-chartjs'

export default {
	extends: Line,
	props: {
		db: {
			type: Object,
			default () {
				return {
					labels: ['A', 'B', 'C'],
					data: [100, 50, 75],
					title: '标题'
				};
			}
		}
	},
	data() {
		return {
			data: {
				labels: this.$props.db.labels,
				datasets: [{
					label: 'Dataset 2',
					backgroundColor: 'rgb(255,255,255)',
					//写成array可以定义每一个data的颜色，如下：
					// backgroundColor:[
					// chartColors.red_bg,
					// chartColors.green_bg,
					// ],
					borderColor: 'rgba(255, 255, 255, 1)',
					data: this.$props.db.data,
					borderWidth: 2,
					hoverBorderColor: 'rgba(149, 255, 97, 1)',
					hoverBackgroundColor: 'rgba(149, 255, 97, .5)'
				}]
			},
			options: {
				title: {
					display: true,
					text: this.$props.db.title,
					position: "top",
					fontColor: "#fff",
					fontSize:14
				},
				responsive: false,
				maintainAspectRatio: false,
				scales: {
					yAxes: [{
						display: true, //垂直值显示
						gridLines: {
							display: true, ///显示背景水平线
							color: 'rgba(255,255,255,.2)',//背景线颜色
							drawOnChartArea:false,//仅边框，数据部分不绘制
							drawTicks: false
						},
						scaleLabel: {
							display: false,
							labelString: '值', //垂直标签
						},
						stacked: false, //第二个数据向第一个数据叠加
						ticks: {
							reverse: false, //true会让0点从顶部开始
							beginAtZero: true, //纵坐标从0开始，false会导致数据从最小值开始
							fontColor: "rgba(255,255,255,.4)", //垂直文本颜色
							padding: 5
						},
					}],
					xAxes: [{
						display: true, //水平值显示
						gridLines: {
							display: false, //显示背景垂直线
							color: 'rgba(255,255,255,.2)',//背景线颜色
							drawOnChartArea:true,//仅边框，数据部分不绘制
							drawTicks: false
						},
						scaleLabel: {
							display: false,
							labelString: '标签' //水平标签
						},
						ticks: {
							reverse: false, //true会让0点从顶部开始
							beginAtZero: true, //纵坐标从0开始，false会导致数据从最小值开始
							fontColor: "rgba(255,255,255,.4)", //垂直文本颜色
							padding: 5
						},
						categoryPercentage: 0.8, //仅bar,每一个数据条的宽度 0~1，1为最大，0最小。默认已设置，可不写
						barPercentage: 0.9 //仅bar,多组数据时，每组数据间的间隙 0~1：0为间隙最大，数据部分最小。默认已设置，可不写
					}],
				},
				legend: {
					display: false, //图例
					position: 'top', //位置
					labels: {
						boxWidth: 12, //图例宽度，默认40
					}
				},
				tooltips: {
					enabled: false
				}
			},
		}
	},
	mounted() {
		var fill_gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 300),
			border_gradient = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 300);

		fill_gradient.addColorStop(0, 'rgba(32, 160, 255, .5)');
		fill_gradient.addColorStop(1, 'rgba(32, 160, 255, .0)');

		border_gradient.addColorStop(0, 'rgba(52, 180, 255, 1)');
		border_gradient.addColorStop(1, 'rgba(52, 180, 255, .3)');

		this.data.datasets[0].backgroundColor = fill_gradient;
		this.data.datasets[0].borderColor = border_gradient;

		this.renderChart(this.data, this.options);
	},
	watch: {
		db: function() {
			this.data.labels = this.$props.db.labels;
			this.data.datasets[0].data = this.$props.db.data;
			this.options.title.text = this.$props.db.title;

			var sorted = JSON.parse(JSON.stringify(this.db.data));
			sorted.sort(function(a,b){return a-b;})

			var min = sorted[0],
				max = (Math.pow(sorted[sorted.length - 1]/10) + 1 ) * 10;

			this.options.scales.yAxes[0].ticks.stepSize = (max - min) / 3;

			this.renderChart(this.data, this.options);
			this.$data._chart.update();
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/charts/LineChart.js